import React from 'react';
import TabbedPage from '../../../../Elements/TabbedPage';
import ClientPrePaymentDetailsInfoTab from './TpRelatedClientPrePaymentDetailsInfoTab';
import TpRelatedClientPrePaymentDetailsPaymentsTab from './TpRelatedClientPrePaymentDetailsPaymentsTab';

export default class TpRealtedClientPrePaymentDetails extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {};
  }

  urlParams = new URLSearchParams(window.location.search);
  PrepaymentId = this.urlParams.get('id');

  static getMenuText() {
    const id = new URLSearchParams(window.location.search).get('id');
    return `Prepayment ${id ? '- ' + id : 'Details'}`;
  }

  tabs = [
    {
      label: 'Information',
      id: 'info',
      icon: 'fa-solid fa-info',
      component: <ClientPrePaymentDetailsInfoTab prepaymentId={this.PrepaymentId} />
    },
    {
      label: 'Third-Party Client Payments',
      id: 'comments',
      icon: 'fa-solid fa-money-check',
      component: <TpRelatedClientPrePaymentDetailsPaymentsTab prepaymentId={this.PrepaymentId} />
    }
  ];

  render() {
    return (
      <div className='contentwrapper'>
        <TabbedPage tabs={this.tabs} />
      </div>
    );
  }
}
